import React, {useEffect, useState} from "react";
import './report.css';
import {useFetch} from "../../../../components/common/FetchProvider";
import {useLocation} from "react-router-dom";
import {columnsDataBankAccountReport} from "../variables/columnsData";
import ColumnsTable from "./ReportTable";
import Loader from "../../../../components/Loader/Loader";
import {formatNumberToInternational} from "../../../../utils/utils";
import logo from "../../../../assets/img/profile/Emblem_of_Angola.png"
import ErrorModal from "./ErrorModal";
export const FINANCIAL_HEAD = process.env.REACT_APP_FINANCIAL_HEAD;
export const EMBAIXADOR = process.env.REACT_APP_EMBAIXADOR;
export const COUNTRY = process.env.REACT_APP_COUNTRY;

const BankAccountReport = () => {
    const fetchWrapper = useFetch();
    const [loading, setLoading] = useState(false);
    const [apiData, setApiData] = useState({});
    const [reportData, setReportData] = useState([]);
    const [footerData, setFooterData] = useState([]);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");


    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // Extract query parameters
    const accountId = queryParams.get("accountId");
    const yearMonth = queryParams.get("yearMonth");

    useEffect(() => {
        fetchbankReport(accountId, yearMonth);
    }, []);

    useEffect(() => {
        if (reportData) {
            let pageBalance = reportData.map((page) => ({
                credit: formatNumberToInternational(page.pageTotalCredit),
                debit: formatNumberToInternational(page.pageTotalDebit),
                balance: formatNumberToInternational(page.totalBalance),
                description: page.footerDescription
            }));
            setFooterData(pageBalance);
        }
    }, [reportData]);

    const fetchbankReport = async (accountId, yearMonth) => {
        setLoading(true);
        try {
            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/reports/bank-account?accountId=${accountId}&yearMonth=${yearMonth}`;
            const userToken = localStorage.getItem("token");
            const response = await fetchWrapper(apiUrl, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            });
            setLoading(false);
            if (response.ok) {
                const responseData = await response.json();
                if (responseData.data) {
                    let data = formatApiNumbers(responseData.data);
                    setApiData(data);
                    setReportData(data.bankReportsPages);
                }
            }
        } catch (error) {
            setLoading(false);
            if (error.body && error.body.responseInfo) {
                setErrorMessage(error.body.responseInfo.message);
                setShowErrorModal(true);
            } else {
                console.error("Error: Unable to handle ", error);
                setErrorMessage("Ocorreu um erro inesperado");
                setShowErrorModal(true);
            }
        }
    }

    const formatApiNumbers = (response) => {
        // Format the exchange rate
        response.exchangeRate = formatNumberToInternational(response.exchangeRate);

        // Iterate through all bank report pages
        response.bankReportsPages.forEach((page) => {
            // Iterate through each bank report in the page
            page.bankReports.forEach((report) => {
                report.credit = formatNumberToInternational(report.credit);
                report.debit = formatNumberToInternational(report.debit);
                report.kwanza = formatNumberToInternational(report.kwanza);
                report.balance = formatNumberToInternational(report.balance);
            });
        });

        return response;
    };


    const handlePrint = () => {
        window.print();
    };

    return (
        <div className="p-2">
            <Loader show={loading}/>
            {showErrorModal &&
                <ErrorModal
                    showErrorModal={showErrorModal}
                    setShowErrorModal={setShowErrorModal}
                    errorMessage={errorMessage}
                />
            }

            {
                reportData && reportData.map((report) => {
                    return <div className="max-w-7xl mx-auto">
                        <div className={report.pageNumber > 1 ? "print-page-break mt-4" : "mt-4"}>

                            {/* Header */}
                          <div className="flex justify-between items-center mb-4 text-black dark:text-white">
                    
                            <div className="flex-1 text-center">
                            <div className="flex items-center justify-center mb-2 h-[100px]">
                                <img
                                    src={logo}
                                    alt="Logo"
                                    className="w-[60px] h-[80px] object-contain"
                                />
                              </div>
                              <h2 className="text-md">MINISTÉRIO DAS RELAÇÕES EXTERIORES</h2>
                              <h2 className="text-md">EMBAIXADA DA REPÚBLICA DE ANGOLA NO {COUNTRY}</h2>
                              <h2 className="text-md font-bold">CONTA CORRENTE COM BANCO</h2>
                                <h2 className="text-md">MÊS DE {apiData.monthNameAndYear}</h2>
                              </div>

                              <div className="text-right">
                                <p className="text-md">Fls: {report.pageNumber}</p>
                                <p className="text-md text-red-600">UNIDADE MONETÁRIA: {apiData.accountCurrency}</p>
                                <p className="text-md">Nº DA CONTA: {apiData.accountNumber}</p>
                                <p className="text-md">BANCO: {apiData.bankName}</p>
                                <p className="text-md text-red-600">Câmbio: {apiData.exchangeRate} AKZ</p>
                              </div>
                            </div>

                            {/* Print Button */}
                            {
                                report.pageNumber === 1 && (
                                    <div className="text-right mb-4">
                                      <button
                                          onClick={handlePrint}
                                          className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 print:hidden">
                                        Print
                                      </button>
                                    </div>
                                )
                            }

                            <div className="mb-4">
                              {report && footerData.length > 0 && report.pageNumber <= footerData.length && (
                                  <ColumnsTable
                                      columnsData={columnsDataBankAccountReport}
                                      tableData={report.bankReports}
                                      footerData={footerData[report.pageNumber - 1]}
                                  />
                              )}
                            </div>

                            {/* Footer */}
                            <div className="flex justify-between mt-4">
                              <div>
                                <p className="text-red-600 text-center">O ADIDO FINANCEIRO</p>
                                <hr className="mt-5 border-t-2 my-2" style={{borderTop: '2px solid black'}}/>
                                <p className="font-bold"> {FINANCIAL_HEAD} </p>
                              </div>
                              <div>
                                <p className="text-red-600 text-center">EMBAIXADORA</p>
                                
                                <hr className="mt-5 border-t-2 my-2" style={{borderTop: '2px solid black'}}/>
                                <p className="font-bold">{EMBAIXADOR}</p>
                              </div>
                            </div>

                          </div>

                        </div>
                      })
            }

        </div>
    )
        ;
};

export default BankAccountReport;
